import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3TransactionsEdit } from "./edit";
import { S3TransactionsNew } from "./new";
import { S3TransactionsTable } from "./table";

export default function S3Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3TransactionsEdit />} />
      <Route index element={<S3TransactionsTable />} />
      <Route path="/new" element={<S3TransactionsNew />} />
    </Routes>
  );
}
